import { Injectable, InjectionToken } from '@angular/core'
import { CmsComponent, Converter } from '@spartacus/core'
import { ConvertedComponentData, FsCatalog, Spacing, TextInput } from '../../types'
import { CmsConverterService, defaultFSCatalog, defaultTextInput } from '../../../services/cms-converter/cms-converter.service'
import { ColorContainerRelatedItemsData } from '../color-container-related-items/color-container-related-items.component.converter'

@Injectable({ providedIn: 'root' })
export class ColorContainerVideoAndContentConverter extends CmsConverterService<ColorContainerVideoAndContentData> {
  convertData (source: CmsComponent) {
    const formData = source?.otherProperties?.formData ?? {}
    return {
      headline: formData.st_headline ?? defaultTextInput,
      text: formData.st_text ?? defaultTextInput,
      label: formData.st_label ?? defaultTextInput,
      textCentered: formData.st_centered_text?.value ?? false,
      alignVideo: formData.st_align_video?.value?.identifier ?? '',
      videoId: formData.st_video ?? '',
      spacing: {
        top: formData.st_spacing_bottom?.value?.identifier ?? '',
        bottom: formData.st_spacing_top?.value?.identifier ?? ''
      },
      captionEnabled: formData.st_enable_caption?.value ?? false,
      captionColor: formData.st_background_color_caption?.value?.identifier ?? '',
      caption: formData.st_caption ?? defaultTextInput,
      captionOverlay: formData.st_caption_text_overlay ?? defaultTextInput,
      descriptionOverlay: formData.st_description_text_overlay ?? defaultTextInput,
      callToActionButtons: formData.st_call_to_actions ?? defaultFSCatalog,
      relatedItems: formData.st_related_items ?? defaultFSCatalog,
      headlineEmpty: formData.st_headline_empty?.value ?? false,
      textEmpty: formData.st_text_empty?.value ?? false
    }
  }
}

export const COLOR_CONTAINER_VIDEO_AND_CONTENT_CONVERTER_TOKEN =
  new InjectionToken<Converter<CmsComponent, ColorContainerVideoAndContentData>>('ColorContainerVideoAndContentConverter')

export interface ColorContainerVideoAndContentData extends ConvertedComponentData {
  text: TextInput;
  textCentered: boolean;
  headline: TextInput;
  label: TextInput;
  spacing: Spacing;
  relatedItems: FsCatalog<ColorContainerRelatedItemsData>;
  alignVideo: string;
  videoId: string;
  captionEnabled: boolean;
  captionColor: string;
  caption: TextInput;
  captionOverlay: TextInput;
  descriptionOverlay: TextInput;
  callToActionButtons: FsCatalog;
  headlineEmpty: boolean;
  textEmpty: boolean;
}
